'use strict';

/** Import frontoffice_app */
import '../frontoffice_app';

/** Import Cart class */
import Cart from '../../../shared/cart/cart'

/** Import AjaxHandler class */
import AjaxHandler from '../../../shared/utility/ajax_handler/ajax_handler'

/** Import APP_CONST */
import APP_CONST from '../../../const';

/**
 * @class CheckoutHandler
 */
class CheckoutHandler
{
    /**
     * @constructor
     */
    constructor ()
    {
        this._loadCartData();
        this._listenUserId();
        this._listenSubmit();
    }

    /**
     * @private
     */
    _listenSubmit ()
    {
        $('[name="order_form"]').submit(function ()
        {
            $("#order_form_submit").attr("disabled", true);
            return true;
        });
    }

    /**
     * @private
     */
    _listenUserId ()
    {
        let userId = $('#user-placeholder').data('user');
        if (userId)
        {
            let link = 'user/' + userId + '/data';
            AjaxHandler.get(link).then((response) =>
            {
                if (response.user)
                {
                    $('#order_form_userId').val(response.user.id);
                    $('#order_form_customerName').val(response.user.firstName);
                    $('#order_form_customerLastname').val(response.user.lastName);
                    $('#order_form_address').val(response.user.address);
                    $('#order_form_city').val(response.user.city);
                    $('#order_form_zip').val(response.user.zip);
                    $('#order_form_country').val(response.user.country);
                    $('#order_form_mail').val(response.user.mail);
                    $('#order_form_phone').val(response.user.phone);
                    if (response.user.company)
                    {
                        $('#order_form_company').val(response.user.company);
                    }
                }
            })
        } else {
            if (!$('#order_form_country').val())
            {
                $('#order_form_country').val('Srbija')
            }
        }
    }

    /**
     * @private
     */
    _loadCartData ()
    {
        let
            cartHtml = '',
            cart = Cart.getCartItems(),
            cartTotals = Cart.getDeliveryTotal()
        ;

        $.each(cart, (k, v) =>
        {
            let displayPrice = parseInt(v.price);
            if (APP_CONST.HIDDEN_DELIVERY === 'true')
            {
                displayPrice = displayPrice + parseInt(v.delivery_price);
            }

            cartHtml += '<div class="shipping-left">' + v.name + ' x ' + v.quantity + '<span class="price">' + (displayPrice * v.quantity) + ' rsd</span>' +
                '<input type="hidden" id="order_form_orderItems_' + k + '_productSlug" name="order_form[orderItems][' + k + '][productSlug]" value="' + v.slug + '" />' +
                '<input type="hidden" id="order_form_orderItems_' + k + '_unitPrice" name="order_form[orderItems][' + k + '][unitPrice]" value="' + v.price + '" />' +
                '<input type="hidden" id="order_form_orderItems_' + k + '_quantity" name="order_form[orderItems][' + k + '][quantity]" value="' + v.quantity + '" />' +
                '<input type="hidden" id="order_form_orderItems_' + k + '_deliveryPerItem" name="order_form[orderItems][' + k + '][deliveryPerItem]" value="' + v.delivery_price + '" />' +
                '<input type="hidden" id="order_form_orderItems_' + k + '_itemTotal" name="order_form[orderItems][' + k + '][itemTotal]" value="' + (v.price * v.quantity) + '" />' +
                '<input type="hidden" id="order_form_orderItems_' + k + '_deliveryTotal" name="order_form[orderItems][' + k + '][deliveryTotal]" value="' + (v.delivery_price * v.quantity) + '" />' +
                '</div>'
        });
        $('#cart-order-items').empty().html(cartHtml);

        $('#order_form_totalChart').val(cartTotals.totalItems);
        $('#order_form_deliveryPrice').val(cartTotals.delivery);
        $('#order_form_total').val(cartTotals.total);

        let displayTotal = parseInt(cartTotals.totalItems);
        if (APP_CONST.HIDDEN_DELIVERY === 'true')
        {
            displayTotal = displayTotal + parseInt(cartTotals.delivery)
        } else {
            $('#delivery-price').empty().html(cartTotals.delivery + ' rsd');
            $('#total').empty().html(cartTotals.total + ' rsd');
        }
        $('#total-chart').empty().html(displayTotal + ' rsd');
    }
}

/** Start CheckoutHandler */
$(document).ready(() => { new CheckoutHandler(); });


// WEBPACK FOOTER //
// ./assets/js/components/frontoffice/pages/checkout.js